import { FC } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button, ButtonProps } from '@frontend/design-system';
import { trackingIds } from '../../../../../tracking-ids';
import { useCallIntelFiltersContext } from '../../context/call-intel-filters.context';

export const FilterTrayToggle: FC<ButtonProps> = (props) => {
  const { trayControlProps, hasAnyFilterModified } = useCallIntelFiltersContext();
  return (
    <Button
      iconName='filter-alt'
      size='large'
      variant='secondary'
      aria-label='Filter'
      {...trayControlProps.triggerProps}
      css={[styles.button, hasAnyFilterModified && styles.dot]}
      trackingId={trackingIds.callIntel.toggleFilterPanel}
      data-testid='call-intel-filter-tray-toggle'
      {...props}
    />
  );
};

const styles = {
  button: css`
    position: relative;
  `,
  dot: css`
    &::after {
      content: '';
      position: absolute;
      top: 4px;
      right: 4px;
      width: 12px;
      height: 12px;
      background-color: ${theme.colors.text.interactive};
      border: 1.5px solid ${theme.colors.white};
      border-radius: ${theme.borderRadius.full};
    }
  `,
};
